import { useContext, createContext } from 'react';

const AuthContext = createContext({
    isAuthed: ():boolean => {return false},
})


function useAuth(context = {isAuthed:false}) {
    return useContext(AuthContext)
}

export {AuthContext, useAuth}